<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-card"></i>
        <div class="mg-l-20">
          <h4>{{ $t("router.通知管理") }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openSend() {
      this.$emit("openSend");
    },
  },
};
</script>
